import * as React from "react";
import PopDetail from "../../popdetail";
import GeneralSelect from "../../general_select";
import CreateService from "../../../service/create";

export default class AddNewFunderPane extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            funder_type: null,
            funder_name: '',
            funderTypeOptions: {
                endpoint: 'setup/funder-types',
                value: 'id',
                label: 'name',
                placeholder: 'Select Funder Type'
            }
        };

        this.handleChanges = this.handleChanges.bind(this);
        this.generalSelect = this.generalSelect.bind(this);
        this.submit = this.submit.bind(this);
    }

    handleChanges = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    generalSelect(data, name) {
        this.setState({
            [name]: data
        });
    }

    async submit() {
        try {
            if (!this.state.funder_type || !this.state.funder_name.trim()) {
                alert('Please fill in all required fields');
                return;
            }

            // Post to setup/funders/create endpoint with lowercase values
            const payload = {
                type: this.state.funder_type.value.toLowerCase(),
                name: this.state.funder_name.toLowerCase()
            };
            await CreateService.createFunder(payload);

            // Close the modal
            PopDetail.dismiss();
            
            // Refresh the funder list in parent component
            if (this.props.onFunderAdded) {
                this.props.onFunderAdded();
            }

        } catch (e) {
            alert(e);
        }
    }

    render() {
        return (
            <div style={{ padding: '8px' }}>
                
                <table style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            <td className={'label'}>Funder Type *</td>
                        </tr>
                        
                        <tr>
                            <td>
                                <GeneralSelect 
                                    onChanges={(e) => this.generalSelect(e, 'funder_type')}
                                    parameters={this.state.funderTypeOptions} 
                                    isMulti={false}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td className={'label'  }>Funder Name *</td>
                        </tr>
                        <tr>
                            <td>
                                <input 
                                    type={'text'} 
                                    name={'funder_name'}
                                    value={this.state.funder_name}
                                    onChange={this.handleChanges}
                                    style={{ width: '100%', padding: '8px' }}
                                    placeholder="Enter funder name"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div style={{ textAlign: 'center', width: '100%', float: 'left', marginTop: '12px' }}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-save'}/>Save Funder
                    </button>
                    <button className={'btn error'} onClick={() => PopDetail.dismiss()}>
                        <span className={'fa fa-times'}/>Cancel
                    </button>
                </div>
            </div>
        );
    }
} 